import { Button, Text, CheckboxField, Toast, Conditional } from 'iq-blueberry'
import Img from 'components/common/Img'
import useAuthorizeSMSStep from './hook'
import './style.styl'
import OutlineAngleRightMini from 'iq-blueberry/dist/reactIcons/OutlineAngleRightMini'
import FormContainer from 'components/common/FormContainer'
import { FormTitle } from 'components/common/FormTitle'
import { isMobile } from 'utils/getDevice'

const AuthorizeSMSStep = ({ fireboltStep }) => {
  const {
    isVisible,
    stepData,
    gotoTutorial,
    handleChange,
    closeModal,
    buttonAction,
    storeLink,
    isLastStep,
    isTutorial,
    isDisabled,
    buttonText,
  } = useAuthorizeSMSStep({ fireboltStep })

  const { imageUrl, alt, label, title, subtitle } = stepData

  return (
    <FormContainer imageSrc={imageUrl}>
      <div className="bbourocard-authorize-sms">
        <div className="bbourocard-authorize-sms__content">
          <Img
            className="bbourocard-authorize-sms__image"
            src={imageUrl}
            alt={alt}
          />
          <div className="bbourocard-authorize-sms__main">
            <Text
              className="bbourocard-authorize-sms__label"
              as="p"
              variant="body-small">
              {label}
            </Text>
            <FormTitle title={title} description={subtitle} />
            <div className="bbourocard-authorize-sms__buttons">
              <Conditional
                condition={!isTutorial}
                renderIf={
                  <CheckboxField
                    label="Autorizei o SMS e quero continuar."
                    onChange={handleChange}
                  />
                }
              />
              <Button
                expand="x"
                justify="center"
                disabled={isDisabled}
                onClick={buttonAction}>
                {buttonText}
              </Button>
              <Conditional
                condition={!isTutorial && isMobile()}
                renderIf={
                  <Button
                    expand="x"
                    justify="center"
                    type="secondary"
                    onClick={() => (window.location.href = storeLink)}>
                    Ir para o app Banco do Brasil
                  </Button>
                }
              />
              <Conditional
                condition={isLastStep}
                renderIf={
                  <Button
                    type="text"
                    expand="x"
                    justify="center"
                    Icon={OutlineAngleRightMini}
                    iconRight
                    onClick={gotoTutorial}>
                    Saiba como autorizar o SMS
                  </Button>
                }
              />
            </div>
            <Conditional
              condition={isMobile()}
              renderIf={
                <div className="bbourocard-authorize-sms__warning">
                  <Img src="images/padlock-icon.svg" />
                  <p>Seus dados estão protegidos</p>
                </div>
              }
            />
            <Conditional
              condition={!isTutorial}
              renderIf={
                <Toast
                  close={closeModal}
                  text="Ops, parece que você não autorizou o SMS..."
                  type="error"
                  isVisible={isVisible}
                />
              }
            />
          </div>
        </div>
      </div>
    </FormContainer>
  )
}

export default AuthorizeSMSStep
